import { connect } from "react-redux";

import IronSourceInitializer from "../components/ironsource/IronSourceInitializer";
import { rewardVideoReady, setIronRV, rewardVideoOpen, rewardVideoComplete, rewardVideoAdBlocked, setRewardVideoSupport, updateRewardVideoStale } from "../actions/rewardVideo";

const mapStateToProps = state => ({
  rewardVideo: state.rewardVideo
});

const mapDispatchToProps = dispatch => ({
  rewardVideoReady: data => {
    dispatch(rewardVideoReady(data));
  },
  setIronRV: data => {
    dispatch(setIronRV(data));
  },
  rewardVideoOpen: data => {
    dispatch(rewardVideoOpen(data));
  },
  rewardVideoComplete: data => {
    dispatch(rewardVideoComplete(data));
  },
  rewardVideoAdBlocked: data => {
    dispatch(rewardVideoAdBlocked(data));
  },
  setRewardVideoSupport: data => {
    dispatch(setRewardVideoSupport(data));
  },
  updateRewardVideoStale: data => {
    dispatch(updateRewardVideoStale(data));
  }
});

const IronSourceInitializerContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(IronSourceInitializer);

export default IronSourceInitializerContainer;


// WEBPACK FOOTER //
// ./src/js/containers/IronSourceInitializerContainer.js